import React, { useState } from 'react';
import { contato } from '../data/mockData';
import { MapPin, Phone, Mail, Clock, Instagram } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validação simples
    if (!formData.nome || !formData.email || !formData.mensagem) {
      toast.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    // Simular envio
    toast.success('Mensagem enviada! Entraremos em contato em breve.');

    // Limpar formulário
    setFormData({
      nome: '',
      email: '',
      telefone: '',
      mensagem: ''
    });
  };

  return (
    <div className="contato-page">
      <div className="contato-hero">
        <h1>Entre em Contato</h1>
        <p>Estamos aqui para ajudar você</p>
      </div>

      <div className="container">
        <div className="contato-grid">
          {/* Informações de Contato */}
          <div className="contato-info">
            <h2>Informações de Contato</h2>
            
            <div className="info-item">
              <MapPin className="info-icon" />
              <div>
                <h3>Endereço</h3>
                <p>{contato.endereco}</p>
                <p>{contato.cidade}</p>
              </div>
            </div>

            <div className="info-item">
              <Phone className="info-icon" />
              <div>
                <h3>Telefone</h3>
                <p>{contato.telefone}</p>
              </div>
            </div>

            <div className="info-item">
              <Mail className="info-icon" />
              <div>
                <h3>Email</h3>
                <p>{contato.email}</p>
              </div>
            </div>

            <div className="info-item">
              <Clock className="info-icon" />
              <div>
                <h3>Horário de Funcionamento</h3>
                <p>{contato.horario.semana}</p>
                <p>{contato.horario.sabado}</p>
                <p>{contato.horario.domingo}</p>
              </div>
            </div>

            <div className="info-item instagram-item">
              <Instagram className="info-icon" />
              <div>
                <h3>Siga-nos no Instagram</h3>
                <a
                  href="https://instagram.com/mordidadesonho_94"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="instagram-link"
                >
                  @mordidadesonho_94
                </a>
                <p className="instagram-desc">Veja nossos produtos e novidades</p>
              </div>
            </div>
          </div>

          {/* Formulário de Contato */}
          <div className="contato-form-container">
            <h2>Envie uma Mensagem</h2>
            <form onSubmit={handleSubmit} className="contato-form">
              <div className="form-group">
                <label htmlFor="nome">Nome *</label>
                <Input
                  id="nome"
                  name="nome"
                  type="text"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Seu nome"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="seu@email.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="telefone">Telefone</label>
                <Input
                  id="telefone"
                  name="telefone"
                  type="tel"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="+351 21 123 4567"
                />
              </div>

              <div className="form-group">
                <label htmlFor="mensagem">Mensagem *</label>
                <Textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  placeholder="Escreva sua mensagem aqui..."
                  rows={5}
                  required
                />
              </div>

              <Button type="submit" className="submit-btn">
                Enviar Mensagem
              </Button>
            </form>
          </div>
        </div>

        {/* Mapa (placeholder) */}
        <div className="mapa-section">
          <div className="mapa-placeholder">
            <MapPin size={48} />
            <p>Rua das Flores, 123 - Lisboa, Portugal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contato;
